
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {Link} from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Schlaflähmung – das tönt erschreckend und ist für Betroffene auch sehr unangenehm. Sie tritt in der Phase des Einschlafens oder noch häufiger während des Aufwachens auf. `}<M mdxType="M">{`Plötzlich hat man das Gefühl, sich nicht mehr bewegen zu können und in seinem Körper gefangen zu sein.`}</M>{` Dieses Lähmungsgefühl, das einige Sekunden oder gar Minuten dauern kann, betrifft das ganze Skelett ausser der Atmung und den Augenbewegungen. Das Gefühl, dass man seine Muskulatur nicht mehr steuern kann, löst oft Ängste oder gar Panik aus, ist aber ungefährlich. Häufig liegt bei der Schlaflähmung eine Narkolepsie vor, sprich, der Schlaf-Wach-Rhythmus ist gestört. Aber auch bei Menschen ohne Narkolepsie-Erkrankungen kann es zu Schlafparalysen kommen. Zum Beispiel bei einer vorhandenen Angsterkrankung oder bei zu viel Stress. Es gibt bis jetzt keine Therapie, die Schlaflähmungen verhindern kann. Ein geregelter Wach-Schlaf-Rhythmus kann allerdings vorsorglich helfen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;